import { tv } from 'tailwind-variants'

export const feedToolbarButtonStyles = tv({
  base: [
    'relative inline-flex h-10 items-center gap-2 no-underline align-middle',
    'rounded-xl bg-background-light px-3 text-sm font-normal leading-none text-primary',
    'cursor-pointer select-none whitespace-nowrap overflow-hidden',
    'transition-colors duration-150 ease-out',
    'hover:bg-tab-hover active:bg-tab-hover',
    'focus-visible:outline-none focus-visible:border-[2px] border-solid focus-visible:border-theme-primary',
  ],
  variants: {
    active: {
      true: [
        'bg-theme-primary text-white shadow-sm',
        'hover:bg-theme-primary/90 active:bg-theme-primary/90',
      ],
    },
    disabled: {
      true: 'opacity-60 cursor-not-allowed pointer-events-none hover:bg-background-light active:bg-background-light',
    },
  },
})
